import React from "react";
import "../Product/Intro.css";  

const Aboutus = () => {
  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading">About Us</h2>
        <p className="description">We Are Professional</p>

        <div className="horizontal-text-container">
          <p>About Us</p>
          <p>/</p>
          <p>About Us</p>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
